/*
 * @Descripttion:
 * @version:
 * @Author: suiyue
 * @email: 2194421430@qq.com
 * @Date: 2021-04-19 12:05:04
 * @LastEditors: sj
 * @LastEditTime: 2022-06-20 16:45:40
 */
import { Button, Col, Form, Modal, Row, Select, Space, Table, Tabs } from "antd"
import React, { useEffect, useRef, useState } from "react"
import styles from "../filing.module.css"
import { TabBar } from "../../../compnents/widgets/TabBar"
import { ExclamationCircleOutlined, PlusOutlined } from "@ant-design/icons"
import { useDispatch, useSelector } from "react-redux"
import {
  selectTenantCityCode,
  selectUserName,
} from "../../../app/applicationSlice"
import { EditableList } from "../../../compnents/list/EditableList"
import { NavBar } from "../../../compnents/nav/NavBar"
import { RootDispatch } from "../../../app/store"
import { getSJWHTokenAsync } from "../../dataMaintenance/organization/data"
import { unwrapResult } from "@reduxjs/toolkit"
import axios from "axios"
import { useQuery } from "../../../utils/HttpUtils"
import { useLocation } from "react-router-dom"
import moment from "moment"
import {
  DateTimeFormatSimpleOnlyOne,
  DateTimeFormatSimplePrintCharge,
} from "../../../models/datetime"
import { PreviewImgOrPdf } from "../Preview"
import { AXIOS_IP, exportPdf } from "../fileUploadService"

export const TraditionalDetail = () => {
  const [form] = Form.useForm()

  const { TabPane } = Tabs

  const query: any = useQuery()

  const dispatch = useDispatch<RootDispatch>()

  const location: any = useLocation()

  const [selectTab, setSelectTab] = useState<any>("1")

  const [updateDoctor, setUpdateDoctor] = useState<any>({})

  const [baseUrl, setBaseUrl] = useState("")

  const [baseType, setBaseType] = useState(true)

  const [stepFirstDetail, setStepFirstDetail] = useState<any>({})

  const [stepSecondDetail, setStepSecondDetail] = useState<any>({})

  const [stepThirdDetail, setStepThirdDetail] = useState<any>({})

  const [token, setToken] = useState("")

  const [previewFile, setPreviewFile] = useState<any>() //预览

  const [exportPdfLoading, setExportPdfLoading] = useState(false)

  const getData = () => {
    dispatch(getSJWHTokenAsync())
      .then(unwrapResult)
      .then((token: any) => {
        setToken(token)
        axios({
          url:
            location.state?.state == 2
              ? `${AXIOS_IP}/filingReviewMentor/detail`
              : `${AXIOS_IP}/filingMentor/detail`,
          headers: {
            "Content-Type": "application/json",
            "His-Auth": token,
          },
          withCredentials: false,
          method: "POST",
          data: { id: location.state?.id, filingType: location.state?.filingType },
        }).then((res) => {
          const data = res.data.data
          setStepFirstDetail(data?.filingApplicantPersonVO)
          setStepSecondDetail(data?.filingGuidanceTeacherVO)
          setStepThirdDetail(data?.filingFollowLearningVO)
        })
      })
  }

  useEffect(() => {
    getData()
  }, [])

  return (
    <>
      <Col>
        <NavBar
          where={["备案管理", "中医医术确有专长医师详情"]}
          backtrace={{
            name: "备案管理",
            path: "/filingManagement",
            state: { fillingType: location.state?.fillingType == 5 ? '5' : '6' },
          }}
          buttons={
            location.state?.state == 1 ? (
              [
                <Button
                  key="0"
                  type="primary"
                  loading={exportPdfLoading}
                  onClick={() =>
                    exportPdf({
                      data: { id: location.state?.id, filingType: location.state?.filingType },
                      token,
                      path: "/filingMentor/generatePdf",
                      fileName: location.state?.filingType == 5 ? "传统医学管理备案详情.pdf" : "中医医术确有专长医师管理备案详情.pdf",
                      callback: setExportPdfLoading,
                    })
                  }
                >
                  导出
                </Button>,
              ]
            ) : (
              <></>
            )
          }
        />
      </Col>
      <div
        style={{
          height: "calc(100% - 20px)",
          overflow: "auto",
          margin: "10px 0px",
          padding: "20px 40px",
          background: "#fff",
          borderRadius: "10px",
          position: "relative",
        }}
      >
        <Form
          form={form}
          labelCol={{ span: selectTab === "3" ? 4 : 8 }}
          wrapperCol={{ span: selectTab === "3" ? 20 : 16 }}
          colon={false}
        >
          <Tabs
            defaultActiveKey={"6"}
            onChange={(v) => {
              setSelectTab(v)
            }}
          >
            <TabPane tab="申报人基本信息" key="1">
              <Row>
                <Col span={24} style={{ fontWeight: 'bold' }}>人员基本信息</Col>
                <Col span={10}>
                  <Form.Item label="姓名">{stepFirstDetail?.name}</Form.Item>
                </Col>
                <Col span={14}>
                  <Form.Item label="性别">{stepFirstDetail?.sexName}</Form.Item>
                </Col>
                <Col span={10}>
                  <Form.Item label="证件类型">
                    {stepFirstDetail?.cardTypeName}
                  </Form.Item>
                </Col>
                <Col span={14}>
                  <Form.Item label="证件号码">
                    {stepFirstDetail?.cardNumber}
                  </Form.Item>
                </Col>
                <Col span={10}>
                  <Form.Item label="出生日期">
                    {stepFirstDetail?.birthDate}
                  </Form.Item>
                </Col>
                <Col span={14}>
                  <Form.Item label="籍贯">
                    {stepFirstDetail?.nativePlace}
                  </Form.Item>
                </Col>
                <Col span={10}>
                  <Form.Item label="学历">
                    {stepFirstDetail?.educationName}
                  </Form.Item>
                </Col>
                <Col span={14}>
                  <Form.Item label="学位">
                    {stepFirstDetail?.degreeName}
                  </Form.Item>
                </Col>
                <Col span={10}>
                  <Form.Item label="民族">
                    {stepFirstDetail?.ethnicGroupName}
                  </Form.Item>
                </Col>
                <Col span={14}>
                  <Form.Item label="单位名称">
                    {stepFirstDetail?.unitName}
                  </Form.Item>
                </Col>
                <Col span={10}>
                  <Form.Item label="通讯地址">
                    {stepFirstDetail?.address}
                  </Form.Item>
                </Col>
                <Col span={14}>
                  <Form.Item label="邮政编码">
                    {stepFirstDetail?.postCode}
                  </Form.Item>
                </Col>
                <Col span={10}>
                  <Form.Item label="现从事主要职业">
                    {stepFirstDetail?.mainOccupation}
                  </Form.Item>
                </Col>
                <Col span={14}>
                  <Form.Item label="联系方式">
                    {stepFirstDetail?.contactInformation}
                  </Form.Item>
                </Col>
                <Col span={10}>
                  <Form.Item label="报考区域">
                    {stepFirstDetail?.registrationArea}
                  </Form.Item>
                </Col>
                <Col span={14}>
                  <Form.Item label="一寸照">
                    {stepFirstDetail.oneInchPhotoFile?.map((v: any) => {
                      return (
                        <span key={v.filePath}>
                          {v.fileName}{" "}
                          <a
                            style={{ color: "#0076FF", padding: "0 20px" }}
                            onClick={() => setPreviewFile(v)}
                          >
                            查看
                          </a>
                        </span>
                      )
                    })}
                  </Form.Item>
                </Col>
                <Col span={10}>
                  <Form.Item label="身份证正面照片">
                    {stepFirstDetail?.idCardPositiveFile?.map((v: any) => {
                      return (
                        <span key={v.filePath}>
                          {v.fileName}{" "}
                          <a
                            style={{ color: "#0076FF", padding: "0 20px" }}
                            onClick={() => setPreviewFile(v)}
                          >
                            查看
                          </a>
                        </span>
                      )
                    })}
                  </Form.Item>
                </Col>
                <Col span={14}>
                  <Form.Item label="身份证反面照片">
                    {stepFirstDetail?.idCardOppositeFile?.map((v: any) => {
                      return (
                        <span key={v.filePath}>
                          {v.fileName}{" "}
                          <a
                            style={{ color: "#0076FF", padding: "0 20px" }}
                            onClick={() => setPreviewFile(v)}
                          >
                            查看
                          </a>
                        </span>
                      )
                    })}
                  </Form.Item>
                </Col>
                <Col span={10}>
                  <Form.Item label="毕业证书">
                    {stepFirstDetail?.graduationCertificateFile?.map(
                      (v: any) => {
                        return (
                          <span key={v.filePath}>
                            {v.fileName}{" "}
                            <a
                              style={{ color: "#0076FF", padding: "0 20px" }}
                              onClick={() => setPreviewFile(v)}
                            >
                              查看
                            </a>
                          </span>
                        )
                      }
                    )}
                  </Form.Item>
                </Col>
              </Row>
              <Row
                style={{
                  fontWeight: "bold",
                  fontSize: "17px",
                }}
              >
                学习经历
              </Row>
              <Row style={{ marginTop: "10px" }}>
                <Col offset={1} span={22}>
                  <Table
                    dataSource={
                      stepFirstDetail?.filingStudyExperienceVOList || []
                    }
                    columns={[
                      {
                        title: "起止年月",
                        width: "10rem",
                        align: "center",
                        ellipsis: true,
                        dataIndex: "startTime",
                        render: (_, t: any) => `${t.startTime} - ${t.endTime}`,
                      },
                      {
                        title: "学校",
                        width: "10rem",
                        align: "center",
                        ellipsis: true,
                        dataIndex: "school",
                      },
                      {
                        title: "专业",
                        width: "10rem",
                        align: "center",
                        ellipsis: true,
                        dataIndex: "professional",
                      },
                      {
                        title: "毕（结、肄）业",
                        width: "8rem",
                        align: "center",
                        ellipsis: true,
                        dataIndex: "graduationStatusName",
                      },
                    ]}
                    rowKey={(t: any) => t.id}
                    pagination={false}
                  />
                </Col>
              </Row>
              <Row
                style={{
                  fontWeight: "bold",
                  fontSize: "17px",
                }}
              >
                工作经历
              </Row>
              <Row style={{ marginTop: "10px" }}>
                <Col offset={1} span={22}>
                  <Table
                    dataSource={
                      stepFirstDetail?.filingWorkExperienceVOList || []
                    }
                    columns={[
                      {
                        title: "起止年月",
                        width: "10rem",
                        align: "center",
                        ellipsis: true,
                        dataIndex: "studyStartDate",
                        render: (_, t: any) =>
                          `${t.studyStartDate} - ${t.studyEndDate}`,
                      },
                      {
                        title: "单位",
                        align: "center",
                        width: "20rem",
                        ellipsis: true,
                        dataIndex: "unit",
                      },
                      {
                        title: "职位",
                        width: "10rem",
                        align: "center",
                        ellipsis: true,
                        dataIndex: "position",
                      },
                    ]}
                    rowKey={(t: any) => t.id}
                    pagination={false}
                  />
                </Col>
              </Row>
            </TabPane>
            <TabPane tab="指导老师基本信息" key="2">
              <Row>
                <Col span={24} style={{ fontWeight: 'bold' }}>人员基本信息</Col>
                <Col span={10}>
                  <Form.Item label="姓名">{stepSecondDetail?.name}</Form.Item>
                </Col>
                <Col span={14}>
                  <Form.Item label="性别">
                    {stepSecondDetail?.sexName}
                  </Form.Item>
                </Col>
                <Col span={10}>
                  <Form.Item label="证件类型">
                    {stepSecondDetail?.cardTypeName}
                  </Form.Item>
                </Col>
                <Col span={14}>
                  <Form.Item label="证件号码">
                    {stepSecondDetail?.cardNo}
                  </Form.Item>
                </Col>
                <Col span={10}>
                  <Form.Item label="学历">
                    {stepSecondDetail?.educationName}
                  </Form.Item>
                </Col>
                <Col span={14}>
                  <Form.Item label="学位">
                    {stepSecondDetail?.degreeName}
                  </Form.Item>
                </Col>
                <Col span={10}>
                  <Form.Item label="职称">
                    {stepSecondDetail?.professionalTitle}
                  </Form.Item>
                </Col>
                <Col span={14}>
                  <Form.Item label="职称证书专业">
                    {stepSecondDetail?.professionalMajor}
                  </Form.Item>
                </Col>
                <Col span={10}>
                  <Form.Item label="主要职业机构">
                    {stepSecondDetail?.professionalOrg}
                  </Form.Item>
                </Col>
                <Col span={14}>
                  <Form.Item label="所在科室">
                    {stepSecondDetail?.department}
                  </Form.Item>
                </Col>
                <Col span={10}>
                  <Form.Item label="多点执业机构">
                    {stepSecondDetail?.multiPointOrg}
                  </Form.Item>
                </Col>
                <Col span={14}>
                  <Form.Item label="工作年限">
                    {stepSecondDetail?.workYears}
                  </Form.Item>
                </Col>
                <Col span={10}>
                  <Form.Item label="医师资格证书编号">
                    {stepSecondDetail?.qualificationCertificateNumber}
                  </Form.Item>
                </Col>
                <Col span={14}>
                  <Form.Item label="医师资格证书">
                    {stepSecondDetail?.qualificationCertificateFile?.map(
                      (v: any) => {
                        return (
                          <span key={v.filePath}>
                            {v.fileName}{" "}
                            <a
                              style={{ color: "#0076FF", padding: "0 20px" }}
                              onClick={() => setPreviewFile(v)}
                            >
                              查看
                            </a>
                          </span>
                        )
                      }
                    )}
                  </Form.Item>
                </Col>
                <Col span={10}>
                  <Form.Item label="医师执业证书编号">
                    {stepSecondDetail?.practiceCertificateNumber}
                  </Form.Item>
                </Col>
                <Col span={14}>
                  <Form.Item label="医师执业证书">
                    {stepSecondDetail?.practiceCertificateFile?.map(
                      (v: any) => {
                        return (
                          <span key={v.filePath}>
                            {v.fileName}{" "}
                            <a
                              style={{ color: "#0076FF", padding: "0 20px" }}
                              onClick={() => setPreviewFile(v)}
                            >
                              查看
                            </a>
                          </span>
                        )
                      }
                    )}
                  </Form.Item>
                </Col>
                <Col span={10}>
                  <Form.Item label="联系电话">
                    {stepSecondDetail?.telNumber}
                  </Form.Item>
                </Col>
                <Col span={14}>
                  <Form.Item label="通讯地址">
                    {stepSecondDetail?.address}
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <Form.Item
                    labelCol={{ span: 10 }}
                    wrapperCol={{ span: 12 }}
                    label="副高以上职称证书或经核准其执业的卫生行政部门出具的从事中医临床工作15年以上证明"
                  >
                    {stepSecondDetail?.advancedCertificateFile?.map(
                      (v: any) => {
                        return (
                          <span key={v.filePath}>
                            {v.fileName}{" "}
                            <a
                              style={{ color: "#0076FF", padding: "0 20px" }}
                              onClick={() => setPreviewFile(v)}
                            >
                              查看
                            </a>
                          </span>
                        )
                      }
                    )}
                  </Form.Item>
                </Col>
              </Row>
              <Row
                style={{
                  fontWeight: "bold",
                  fontSize: "17px",
                }}
              >
                从事专业工作经历
              </Row>
              <Row style={{ marginTop: "10px" }}>
                <Col offset={1} span={22}>
                  <Table
                    dataSource={
                      stepSecondDetail?.filingWorkExperienceVOList || []
                    }
                    columns={[
                      {
                        title: "起止时间",
                        width: "10rem",
                        align: "center",
                        ellipsis: true,
                        dataIndex: "studyStartDate",
                        render: (_, t: any) =>
                          `${t.studyStartDate} - ${t.studyEndDate}`,
                      },
                      {
                        title: "单位",
                        width: "10rem",
                        align: "center",
                        ellipsis: true,
                        dataIndex: "unit",
                      },
                      {
                        title: "科室",
                        width: "10rem",
                        align: "center",
                        ellipsis: true,
                        dataIndex: "department",
                      },
                      {
                        title: "职位/职称",
                        width: "8rem",
                        align: "center",
                        ellipsis: true,
                        dataIndex: "position",
                      },
                    ]}
                    rowKey={(t: any) => t.id}
                    pagination={false}
                  />
                </Col>
              </Row>
            </TabPane>
            <TabPane tab="跟师学习情况" key="3">
              <Row>
                <Col span={24} style={{ fontWeight: 'bold' }}>跟师学习情况</Col>
                <Col span={24}>
                  <Form.Item label="合同公证时间">
                    {stepThirdDetail?.contractNotarizationDate}
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <Form.Item label="公证合同的跟师学习时间">
                    {stepThirdDetail?.learningStartDate + '-' + stepThirdDetail?.contractNotarizationDate}
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <Form.Item label="合同备案卫健委名称">
                    {stepThirdDetail?.healthCommissionName}
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <Form.Item label="跟师学习的学时数">
                    {stepThirdDetail?.learningClassHours}
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <Form.Item label="跟师学习医疗机构名称">
                    {stepThirdDetail?.learningOrgName}
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <Form.Item label="跟师学习科室">
                    {stepThirdDetail?.learningOrgDept}
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <Form.Item label="跟师学习医疗机构地址">
                    {stepThirdDetail?.learningOrgAddress}
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <Form.Item label="首次参加全省出师考核年度">
                    {stepThirdDetail?.firstApprenticeshipAssessmentYear}
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <Form.Item label="上一年度临床实践技能考核情况">
                    {stepThirdDetail?.lastYearAssessmentStatusName}
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <Form.Item label="传统医学师承关系合同书">
                    {stepThirdDetail?.masterApprenticeContractFile?.map(
                      (v: any) => {
                        return (
                          <span key={v.filePath}>
                            {v.fileName}{" "}
                            <a
                              style={{ color: "#0076FF", padding: "0 20px" }}
                              onClick={() => setPreviewFile(v)}
                            >
                              查看
                            </a>
                          </span>
                        )
                      }
                    )}
                  </Form.Item>
                </Col>
                {location.state?.filingType == 6 && <Col span={24}>
                  <Form.Item label="临床实践协议书">
                    {stepThirdDetail?.clinicalPracticeFile?.map(
                      (v: any) => {
                        return (
                          <span key={v.filePath}>
                            {v.fileName}{" "}
                            <a
                              style={{ color: "#0076FF", padding: "0 20px" }}
                              onClick={() => setPreviewFile(v)}
                            >
                              查看
                            </a>
                          </span>
                        )
                      }
                    )}
                  </Form.Item>
                </Col>}
                <Col span={24}>
                  <Form.Item label="公证书">
                    {stepThirdDetail?.notarizedCertificateFile?.map(
                      (v: any) => {
                        return (
                          <span key={v.filePath}>
                            {v.fileName}{" "}
                            <a
                              style={{ color: "#0076FF", padding: "0 20px" }}
                              onClick={() => setPreviewFile(v)}
                            >
                              查看
                            </a>
                          </span>
                        )
                      }
                    )}
                  </Form.Item>
                </Col>
              </Row>
              {location.state?.state == 1 && <>
                <Row
                  style={{
                    fontWeight: "bold",
                    fontSize: "17px",
                  }}
                >
                  学习情况报告
                </Row>
                <Row style={{ marginTop: "10px" }}>
                  <Col offset={1} span={22}>
                    <Table
                      dataSource={
                        stepThirdDetail?.filingStudySituationVOList || []
                      }
                      columns={[
                        {
                          title: "序号",
                          key: "no",
                          align: "center",
                          width: "4rem",
                          render: (_1, _2, i) => `${i + 1}`,
                        },
                        {
                          title: "提交时间",
                          width: "10rem",
                          align: "center",
                          ellipsis: true,
                          dataIndex: "createTime",
                          render: (_, t) => {
                            return t.createTime
                              ? moment(t.createTime).format(
                                  DateTimeFormatSimpleOnlyOne
                                )
                              : "-"
                          },
                        },
                        {
                          title: "状态",
                          width: "8rem",
                          align: "center",
                          ellipsis: true,
                          dataIndex: "reviewStatusName",
                        },
                        {
                          title: "操作",
                          align: "center",
                          width: "8rem",
                          ellipsis: true,
                          render: function Element(_, m) {
                            return (
                              <Space>
                                <Button
                                  type="link"
                                  onClick={() =>
                                    setPreviewFile(m.lastYearFile?.[0])
                                  }
                                >
                                  查看报告
                                </Button>
                              </Space>
                            )
                          },
                        },
                      ]}
                      rowKey={(t: any) => t.id}
                      pagination={false}
                    />
                  </Col>
                </Row>
              </>}
            </TabPane>
          </Tabs>
        </Form>
      </div>

      <PreviewImgOrPdf
        token={token}
        AXIOS_IP={AXIOS_IP}
        file={previewFile}
        onClose={() => setPreviewFile(null)}
      />
    </>
  )
}
